import { jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Alert, AlertTitle } from '@mui/material';
export const UpdateFirmwareState = memo(function UpdateFirmwareState(props) {
    const { completed, in_progress, error, result, serial, hw_type, show_info, onHide } = props;
    const [text, color] = useMemo(() => {
        if (error) {
            return [result ?? 'Неизвестная ошибка', 'error'];
        }
        if (completed) {
            return [result ?? 'Обновление завершено', 'success'];
        }
        if (in_progress) {
            return ['В процессе обновления...', 'info'];
        }
        return [result ?? 'Ожидаем начала обновления...', 'info'];
    }, [error, result, completed, in_progress]);
    return (_jsxs(Alert, { severity: color, onClose: onHide, sx: { borderRadius: 0 }, children: [show_info && (_jsxs(AlertTitle, { children: ["\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430 s\\n:", serial, "\u00A0(", hw_type, ")"] })), text] }));
});
